import { render, staticRenderFns } from "./ReportUnregisteredServices.vue?vue&type=template&id=2e45ec58"
import script from "./ReportUnregisteredServices.vue?vue&type=script&lang=js"
export * from "./ReportUnregisteredServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports